import * as yup from 'yup';

const AddAdminSchema = yup.object({
  email: yup
    .string('Email')
    .email('Enter a valid email')
    .required('Email is required')

  ,
  password: yup
    .string('Enter your password')
    .min(8, 'Password should be of minimum 8 characters length')
    .required('Password is required')
  ,
  name: yup
    .string('Name')
    .required('Name is required')
    .min(3, 'Name should be of minimum 3 characters length')
    .max(35, 'Name should be of maximum 35 characters length')
  ,
  contact:  yup
    .string('contact')
    .required('Contact is required'),
  userType: yup
    .string('Select user type')
    .required('User type is required'),

});
const initialValues = {
  email: '',
  password: '',
  name: '',
  contact: '',
  userType: ''
};

const AddAdminValidation = {
  initialValues,
  AddAdminSchema
};

export default  AddAdminValidation;